import React from 'react';
import { Tooltip } from 'antd';

interface ITooltipForElement {
	title: string;
}

const TooltipForElement: React.FC<ITooltipForElement> = React.memo(({ children, title }) => {
	return (
		<Tooltip
			overlayInnerStyle={{
				padding: '7px 12px',
				borderRadius: '3px',
				fontSize: '15px',
				fontWeight: 600,
				color: '#5B32B4',
			}}
			color="#D4CDE4"
			title={title}
			placement="topLeft">
			{children}
		</Tooltip>
	);
});

export default TooltipForElement;
